import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_delivery_received.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_f_announce_red.svg'
import _imports_2 from '@/app/ui/assets/svg/new-cod.svg'
import _imports_3 from '@/app/ui/assets/svg/new-cod-disabled.svg'
import _imports_4 from '@/app/ui/assets/svg/new-dfod.svg'
import _imports_5 from '@/app/ui/assets/svg/new-dfod-disabled.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-6d909e48")

_pushScopeId("data-v-6d909e48")
const _hoisted_1 = { class: "flex flex-row items-center gap-2 h-7" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "delivery-service"
}, null, -1)
const _hoisted_3 = { class: "font-semibold text-sm text-gray-lp-300" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-row items-center gap-1 px-2 py-1 bg-red-lp-1300 text-xs font-medium rounded-md text-red-lp-100"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "w-5 h-5",
  src: _imports_1,
  alt: "announce"
}, null, -1)
const _hoisted_6 = { class: "flex flex-row gap-2 mt-3 pb-2" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "delivery-service-logo",
  enabled: "",
  src: _imports_2,
  alt: "cod-logo-enabled"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  class: "delivery-service-logo",
  disabled: "",
  src: _imports_3,
  alt: "cod-logo-disabled"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "delivery-service-logo",
  enabled: "",
  src: _imports_4,
  alt: "dfod-logo-enabled"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  class: "delivery-service-logo",
  disabled: "",
  src: _imports_5,
  alt: "dfod-logo-disabled"
}, null, -1)
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = { class: "tooltip-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", {
      class: "bg-white rounded-xl p-3 border border-gray-lp-1400 w-full",
      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.changeFieldIndex && _ctx.changeFieldIndex(...args)))
    }, [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("bookingV3.deliveryService.label")), 1),
        (_ctx.isDisabledCOD)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _hoisted_5,
              _createVNode("div", null, _toDisplayString(_ctx.disabledCODMessage), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("label", {
          id: _ctx.idNonCod,
          class: "label-delivery-service",
          for: "non-cod"
        }, [
          _createVNode("input", {
            type: "radio",
            id: "non-cod",
            name: "delivery-service",
            value: "non-cod",
            class: "absolute",
            checked: _ctx.modelValue === 'non-cod',
            disabled: _ctx.disabled && !_ctx.checkSelectedDisabledEdit(),
            onChange: _cache[1] || (_cache[1] = () => _ctx.onChangeDeliveryService('non-cod'))
          }, null, 40, ["checked", "disabled"]),
          _createVNode("div", {
            class: "delivery-service-button",
            selected: _ctx.modelValue === 'non-cod',
            disabled: _ctx.disabled && !_ctx.checkSelectedDisabledEdit()
          }, " Non COD ", 8, ["selected", "disabled"])
        ], 8, ["id"]),
        _createVNode("label", {
          id: _ctx.idCod,
          class: "label-delivery-service",
          for: "cod",
          onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleTooltip($event, 'cod'))),
          onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideTooltip($event, 'cod')))
        }, [
          _createVNode("input", {
            type: "radio",
            id: "cod",
            name: "delivery-service",
            value: "cod",
            class: "absolute",
            checked: _ctx.modelValue === 'cod',
            disabled: _ctx.isDisabledCODButton && !_ctx.checkSelectedDisabledEdit('cod'),
            onChange: _cache[2] || (_cache[2] = () => _ctx.onChangeDeliveryService('cod'))
          }, null, 40, ["checked", "disabled"]),
          _createVNode("div", {
            class: "delivery-service-button",
            disabled: _ctx.isDisabledCODButton && !_ctx.checkSelectedDisabledEdit('cod'),
            selected: _ctx.modelValue === 'cod'
          }, [
            _hoisted_7,
            _hoisted_8
          ], 8, ["disabled", "selected"])
        ], 40, ["id"]),
        _createVNode("label", {
          id: _ctx.idDfod,
          for: "dfod",
          class: "label-delivery-service",
          onMouseenter: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleTooltip($event, 'dfod'))),
          onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.hideTooltip($event, 'dfod')))
        }, [
          _createVNode("input", {
            type: "radio",
            id: "dfod",
            name: "delivery-service",
            value: "dfod",
            class: "absolute",
            disabled: _ctx.isDisabledDFODButton && !_ctx.checkSelectedDisabledEdit('dfod'),
            checked: _ctx.modelValue === 'dfod',
            onChange: _cache[5] || (_cache[5] = () => _ctx.onChangeDeliveryService('dfod'))
          }, null, 40, ["disabled", "checked"]),
          _createVNode("div", {
            class: "delivery-service-button",
            disabled: _ctx.isDisabledDFODButton && !_ctx.checkSelectedDisabledEdit('dfod'),
            selected: _ctx.modelValue === 'dfod'
          }, [
            _hoisted_9,
            _hoisted_10
          ], 8, ["disabled", "selected"])
        ], 40, ["id"])
      ]),
      _createVNode("div", {
        class: ["border-t border-gray-lp-2100 pt-2 flex flex-row gap-2 items-center relative", { invisible: !_ctx.isShowWoodpacking }],
        style: {"height":"29px"}
      }, [
        (_ctx.isShowWoodpacking && _ctx.isLoadingWoodpacking)
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              height: "1.8rem",
              width: "14rem"
            }))
          : _createCommentVNode("", true),
        (_ctx.isShowWoodpacking && !_ctx.isLoadingWoodpacking)
          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_Checkbox, {
                class: "woodpacking-checkbox",
                modelValue: _ctx.woodpackingModel,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.woodpackingModel = $event)),
                binary: true,
                disabled: !_ctx.isAllowWoodpacking || _ctx.isEdit
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode("div", {
                class: ["flex flex-row gap-1 items-center text-sm text-gray-lp-300", { 'text-gray-lp-600': !_ctx.isAllowWoodpacking }]
              }, [
                _createVNode("div", null, _toDisplayString(_ctx.$t("bookingShipment.column.woodPacking")), 1),
                _createVNode("div", _hoisted_11, "(" + _toDisplayString(_ctx.additionalWoodpackingPrice) + "/kg)", 1)
              ], 2)
            ], 64))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createVNode(_component_OverlayPanel, {
      id: "delivery-service-tooltip-container",
      ref: "delivery-service-tooltip",
      class: "delivery-service-tooltip-container",
      alignOverlay: "",
      horizontalAlign: "center",
      style: _ctx.tooltipStyle
    }, {
      default: _withId(() => [
        _createVNode("h3", _hoisted_12, _toDisplayString(_ctx.deliveryTooltipContent.title), 1),
        _createVNode("ul", _hoisted_13, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deliveryTooltipContent.content, (content, index) => {
            return _withDirectives((_openBlock(), _createBlock("li", { key: index }, null, 512)), [
              [_directive_sanitize_html, content]
            ])
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["style"])
  ], 64))
})